import styled from "styled-components";
import { Colors } from "../config/Constants";

type ToggleProps = {
  uniqueName: string;
  isChecked: boolean;
  onChange: (state: boolean) => void;
  isDisabled?: boolean;
};

const Toggle = ({
  uniqueName,
  isChecked,
  onChange,
  isDisabled,
}: ToggleProps) => {
  const handleOnChange = (event: any) => {
    onChange(event.target.checked);
  };

  return (
    <div>
      <ToggleSwitch>
        <ToggleInput
          type="checkbox"
          id={uniqueName}
          onChange={handleOnChange}
          checked={isChecked}
          disabled={isDisabled}
        />
        <ToggleLabel htmlFor={uniqueName}>
          <SpanInner />
          <SpanSwitch />
        </ToggleLabel>
      </ToggleSwitch>
    </div>
  );
};

export default Toggle;

const ToggleSwitch = styled.div`
  position: relative;
  width: 2.5rem;
  height: 1.5rem;
  display: inline-block;
  text-align: left;
`;
const ToggleLabel = styled.label`
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 0 solid ${Colors.mediumLightBlue};
  border-radius: 1.25rem;
`;
const SpanInner = styled.span`
  display: block;
  width: 200%;
  margin-left: -100%;
  &:before,
  &:after {
    float: left;
    width: 50%;
    height: 1.5rem;
    padding: 0;
    line-height: 2.25rem;
    color: ${Colors.white};
    font-weight: bold;
    box-sizing: border-box;
  }
  &:before {
    content: "";
    background-color: ${Colors.black};
    color: ${Colors.white};
  }
  &:after {
    content: "";
    padding-right: 0.625rem;
    background-color: ${Colors.mediumLightBlue};
    color: ${Colors.white};
    text-align: right;
  }
`;
const SpanSwitch = styled.span`
  display: block;
  width: 1rem;
  height: 1rem;
  margin: 0.25rem;
  background: ${Colors.white};
  position: absolute;
  top: 0;
  bottom: 0;
  border-radius: 1.25rem;
`;
const ToggleInput = styled.input`
  display: none;
  &:checked + ${ToggleLabel} ${SpanInner} {
    margin-left: 0;
  }
  &:checked + ${ToggleLabel} ${SpanSwitch} {
    right: 0px;
  }
  &:disabled {
    + ${ToggleLabel} {
      cursor: not-allowed;
    }
    + ${ToggleLabel} ${SpanSwitch} {
      background: gray;
    }
  }
`;
